<template>
<modal v-ref:modal :is-shown.sync="isShown" size="lg">
  <div slot="content">
    <edit
        :display="showingModal == 'edit'"
        :shop="shop"
        :shops="shops"
        :staffs="staffs"
        :availabilities="availabilities"
        :menus="menus"
        :dyestuffs="dyestuffs"
        :business-hour="businessHour"
    ></edit>
    <customer-finder :display="showingModal == 'customer-finder'" :shop="shop" :shops="shops"></customer-finder>
    <time-select
      :display="showingModal === 'timeSelect'"
      :business-hour="businessHour"
      :menus="menus"
      :shop="shop"
    ></time-select>
    <remove :display="showingModal == 'remove'" :shop="shop"></remove>
  </div><!-- content -->
</modal>
</template>

<script lang="babel">
import moment from 'moment'
import Cookies from 'js.cookie'
import { getAccount } from 'getters'

export default {
  name: 'reservation-table-modal-form',
  props: {
    shop: {
      type: Object,
      required: true,
    },
    shops: {
      type: Array,
      required: true,
    },
    staffs: {
      type: Array,
      required: true,
    },
    availabilities: {
      type: Array,
      required: true,
    },
    menus: {
      type: Array,
      required: true,
    },
    dyestuffs: {
      type: Array,
      required: true,
    },
    businessHour: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      isShown: false,
      currentDate: null,
      showingModal: 'edit',
    }
  },
  computed: {
    restrictReserveTime () {
      if (this.loggedInAccount.username === 'call') {
        return true
      }
      if (!this.shop.restrictReserveTime) {
        return false
      }
      if (!this.currentDate) {
        return false
      }

      const gracePeriod = this.shop.restrictGracePeriod || 0

      if (moment().startOf('date').diff(moment(this.currentDate), 'days') >= -gracePeriod) {
        return false
      }
      if (this.shop.restrictStartDate) {
        if (moment(this.currentDate).isBefore(this.shop.restrictStartDate, 'date')) {
          return false
        }
      }
      return true
    },
  },
  events: {
    'reservation-created': function (reservation) {
      this.isShown = false
      return true
    },
    'reservation-updated': function (reservation) {
      this.isShown = false
      return true
    },
    'switch-modal': function(modal, events = []) {
      this.showingModal = modal
      events.forEach(e => this.$broadcast(`${modal}-${e.name}`, e.options))
    },
    'time-select': function (startAt, menu, menuOptions) {
      this.$broadcast('time-select', startAt, menu, menuOptions)
    },
    'show-time-select': function (startAt, menu, menuOptions, reservationPk) {
      this.$broadcast('show-time-select', startAt, menu, menuOptions, reservationPk)
      this.showingModal = 'timeSelect'
    },
    'hide-modal': function() {
      this.isShown = false
    },
    'modal-shown': function() {
    },
    'modal-hidden': function() {
    },
  },
  methods: {
    create(createAt) {
      this.currentDate = createAt
      if (this.restrictReserveTime) {
        this.$broadcast('prepare-create', createAt)
        this.$emit('switch-modal', 'timeSelect')
        this.isShown = true
      } else {
        this.$broadcast('prepare-create', createAt)
        this.$emit('switch-modal', 'edit')
        this.isShown = true
      }
    },
    update(reservation) {
      this.currentDate = reservation.startAt
      this.$broadcast('prepare-update', reservation)
      this.$emit('switch-modal', 'edit')
      this.isShown = true
    },
  },
  vuex: {
    getters: {
      loggedInAccount: getAccount,
    },
  },
  components: {
    modal: require('ui/modal.vue'),
    remove: require('./remove.vue'),
    edit: require('./edit.vue'),
    customerFinder: require('./customer-finder.vue'),
    timeSelect: require('./time-select.vue'),
  },
}
</script>



// WEBPACK FOOTER //
// index.vue?a724867c